import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { BannerNotification } from '@frontend/design-system';
import { useGetPayoutsPausingStatus } from '../../hooks/use-get-payouts-pausing-status';

const bannerSpacing = {
  marginBottom: theme.spacing(3),
};

export const MerchantAlertBanner = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { message, payoutsPausingStatus } = useGetPayoutsPausingStatus(selectedLocationIds[0]);

  if (payoutsPausingStatus === 'active') return;

  if (payoutsPausingStatus === 'warn')
    return <BannerNotification message={message} status='warn' css={bannerSpacing} />;

  if (payoutsPausingStatus === 'alert' || payoutsPausingStatus === 'error')
    return <BannerNotification message={message} status='error' css={bannerSpacing} />;

  return;
};
